import { useCallback } from 'react';
import Yup, { Schema, ValidationError } from 'yup';
import { toNestError } from '@hookform/resolvers';
import { FieldError } from 'react-hook-form';

export type CustomError = {
  path: string;
  type: string;
  message?: string;
  params: object;
};

const parseErrorSchema = (error: Yup.ValidationError, validateAllFieldCriteria: boolean) => {
  return error.inner.reduce<Record<string, any>>((previous, error) => {
    const previousError = previous[error.path] ? previous[error.path] : [];
    if (!previous[error.path!]) {
      previous[error.path!] = [
        ...previousError,
        { message: error.message, type: error.type!, params: error.params! } as FieldError,
      ];
    }
    return previous;
  }, {});
};

const useYupValidationResolver = (validationSchema: Schema<any>) =>
  useCallback(
    async (data: any, context, options) => {
      try {
        const values = await validationSchema.validate(data, {
          abortEarly: false,
        });

        return {
          values,
          errors: {},
        };
      } catch (errors) {
        return {
          values: {},
          errors: toNestError(
            parseErrorSchema(
              errors as ValidationError,
              !options.shouldUseNativeValidation && options.criteriaMode === 'all',
            ),
            options,
          ),
        };
      }
    },
    [validationSchema],
  );

export default useYupValidationResolver;
